"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.all = all;
exports.update = update;
exports.patch = patch;
exports.reset = reset;
exports.uploadAvatar = uploadAvatar;
exports.listForwardEmail = listForwardEmail;
exports.addForwardEmail = addForwardEmail;
exports.resendRecoveryVerifyEmail = resendRecoveryVerifyEmail;
exports.deleteForwardEmail = deleteForwardEmail;
exports.exportData = exportData;
exports.fetchExportData = fetchExportData;
exports.updateSignature = updateSignature;
exports.updateSignatureExt = updateSignatureExt;
exports.uploadInboxZeroBackground = uploadInboxZeroBackground;
exports.deleteInboxZeroBackground = deleteInboxZeroBackground;
exports.unsubscribeWelcomeEmails = unsubscribeWelcomeEmails;
exports.removeRecoveryEmail = exports.updateRecoveryEmail = exports.removeRecoveryPhone = exports.updateRecoveryPhone = exports.verifyEmailCode = exports.sendEmailCode = exports.verifySMSCode = exports.sendSMSCode = exports.endpoints = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _moment = _interopRequireDefault(require("moment"));

var _set = _interopRequireDefault(require("lodash/set"));

var _get = _interopRequireDefault(require("lodash/get"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _requests = require("@edison/requests");

var _functools = require("@edison/functools");

var _utils = require("./utils");

var _constants = require("../utils/constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var endpoints = {
  all: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/settings");
    }
  },
  update: {
    method: 'PUT',
    url: function url() {
      return "/".concat(_constants.API_V1, "/settings");
    }
  },
  patch: {
    method: 'PATCH',
    url: function url() {
      return "/".concat(_constants.API_V1, "/settings");
    }
  },
  reset: {
    method: 'PUT',
    url: function url() {
      return "/".concat(_constants.API_V1, "/settings/reset");
    }
  },
  uploadAvatar: {
    method: 'POST',
    url: function url(id) {
      return "/".concat(_constants.API_V1, "/profile/").concat(id, "/avatar");
    }
  },
  // Forwarding Email
  listForwardEmail: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/settings/forward_email_settings");
    }
  },
  addForwardEmail: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/settings/forward_email_settings");
    }
  },
  deleteForwardEmail: {
    method: 'DELETE',
    url: function url() {
      return "/".concat(_constants.API_V1, "/settings/forward_email_settings");
    }
  },
  exportData: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/export");
    }
  },
  fetchExportData: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/export");
    }
  },
  updateSignature: {
    method: 'PUT',
    url: function url() {
      return "/".concat(_constants.API_V1, "/settings/signature");
    }
  },
  updateSignatureExt: {
    method: 'PUT',
    url: function url() {
      return "/".concat(_constants.API_V1, "/settings/signature_ext");
    }
  },
  // Custom inbox zero background
  uploadInboxZeroBackground: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/settings/bkimg");
    }
  },
  getInboxZeroBackground: {
    method: 'GET',
    url: function url(name) {
      return "/".concat(_constants.API_V1, "/settings/bkimg/").concat(name);
    }
  },
  deleteInboxZeroBackground: {
    method: 'DELETE',
    url: function url(name) {
      return "/".concat(_constants.API_V1, "/settings/bkimg/").concat(name);
    }
  },
  unsubscribeWelcomeEmails: {
    method: 'DELETE',
    url: function url() {
      return "/".concat(_constants.API_V1, "/").concat(_constants.NOAUTH_PREFIX, "/welcome_email/unsubscribe");
    }
  },
  resendRecoveryVerifyEmail: {
    method: 'PUT',
    url: function url() {
      return "/".concat(_constants.API_V1, "/settings/resend_verify_email");
    }
  },
  sendSMSCode: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/").concat(_constants.NOAUTH_PREFIX, "/sms_auth/gen");
    }
  },
  verifySMSCode: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/").concat(_constants.NOAUTH_PREFIX, "/sms_auth/verify");
    }
  },
  sendEmailCode: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/").concat(_constants.NOAUTH_PREFIX, "/email_auth/gen");
    }
  },
  verifyEmailCode: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/").concat(_constants.NOAUTH_PREFIX, "/email_auth/verify");
    }
  },
  updateRecoveryPhone: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/").concat(_constants.NOAUTH_PREFIX, "/settings/update_recovery_phone");
    }
  },
  updateRecoveryEmail: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/").concat(_constants.NOAUTH_PREFIX, "/settings/update_recovery_email");
    }
  },
  removeRecoveryPhone: {
    method: 'DELETE',
    url: function url() {
      return "/".concat(_constants.API_V1, "/").concat(_constants.NOAUTH_PREFIX, "/settings/delete_recovery_phone");
    }
  },
  removeRecoveryEmail: {
    method: 'DELETE',
    url: function url() {
      return "/".concat(_constants.API_V1, "/").concat(_constants.NOAUTH_PREFIX, "/settings/delete_verify_email");
    }
  }
}; // Helper functions to patch the settings

exports.endpoints = endpoints;

function patchDefaultSettings(settings) {
  var next = _objectSpread({}, settings);

  for (var key in _constants.DEFAULT_SETTING_VALUES) {
    (0, _set["default"])(next, "".concat(key), _constants.DEFAULT_SETTING_VALUES[key]);
  }

  return next;
}

function patchUndoDuration(settings) {
  var undoDuration = (0, _get["default"])(settings, 'general.display.undoDuration', _constants.MINIMUM_UNDO_DURATION);

  if (undoDuration < _constants.MINIMUM_UNDO_DURATION) {
    return (0, _set["default"])(_objectSpread({}, settings), 'general.display.undoDuration', _constants.MINIMUM_UNDO_DURATION);
  } else return settings;
}

function patchInboxZeroBackgroundMode(settings) {
  var field = 'general.display.backgroundImageMode';
  var mode = (0, _get["default"])(settings, field, undefined);
  if ((0, _isNil["default"])(mode)) return settings;
  var enabled = true;

  if (mode === _constants.inboxZeroBackgroundTypes.NONE) {
    enabled = false;
  }

  return (0, _set["default"])(_objectSpread({}, settings), field, enabled);
}

function reverseInboxZeroBackgroundMode(settings) {
  var field = 'general.display.backgroundImageMode';
  var backgroundFilename = 'genernal.display.backgroundImageFilename';
  var enabled = (0, _get["default"])(settings, field, undefined);
  if ((0, _isNil["default"])(enabled)) return settings;
  var mode = _constants.inboxZeroBackgroundTypes.AUTO;

  if (!enabled) {
    mode = _constants.inboxZeroBackgroundTypes.NONE;
  } else if (backgroundFilename) {
    mode = _constants.inboxZeroBackgroundTypes.CUSTOM;
  }

  return (0, _set["default"])(_objectSpread({}, settings), field, mode);
}

/**
 * Fetch all the setting configurations from backend API
 *
 * @public
 * @param {Auth} auth - User validated authentication
 * @returns {Promise<SettingsResponse>}
 */
function all(_x) {
  return _all.apply(this, arguments);
}

function _all() {
  _all = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(_ref) {
    var auth, options, _endpoints$all, method, url, res, _res$result, splitMetas, settings;

    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            auth = _ref.auth;
            options = (0, _utils.withAuth)(auth)(_utils.defaultOptionals);
            _endpoints$all = endpoints.all, method = _endpoints$all.method, url = _endpoints$all.url;
            _context4.next = 5;
            return (0, _requests.request)(url(), method, options);

          case 5:
            res = _context4.sent;
            _res$result = res.result, splitMetas = _res$result.splitMetas, settings = (0, _objectWithoutProperties2["default"])(_res$result, ["splitMetas"]);
            return _context4.abrupt("return", _objectSpread(_objectSpread({}, res), {}, {
              result: {
                splitMetas: splitMetas,
                base: (0, _functools.compose)( // Set default values
                function (input) {
                  return patchDefaultSettings(input);
                }, // Validation for undo duration
                function (input) {
                  return patchUndoDuration(input);
                }, // Turn background mode to booleawn
                function (input) {
                  return patchInboxZeroBackgroundMode(input);
                })(settings)
              }
            }));

          case 8:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _all.apply(this, arguments);
}

/**
 * Update settings for specified user
 *
 * @public
 * @param {Settings} settings - Settings to update
 * @param {Auth} auth - User validated authentication
 * @returns {Promise<SettingsUpdateResponse>}
 */
function update(_x2, _x3) {
  return _update.apply(this, arguments);
}

function _update() {
  _update = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(settings, _ref2) {
    var auth, options, _endpoints$update, method, url, res;

    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            auth = _ref2.auth;
            options = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)((0, _functools.compose)(_requests.demomentize, reverseInboxZeroBackgroundMode)(settings)))(_utils.defaultOptionals);
            _endpoints$update = endpoints.update, method = _endpoints$update.method, url = _endpoints$update.url;
            _context5.next = 5;
            return (0, _requests.request)(url(), method, options);

          case 5:
            res = _context5.sent;
            return _context5.abrupt("return", res);

          case 7:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _update.apply(this, arguments);
}

/**
 * Patch settings value for specified fields
 *
 * @public
 * @param {Object} partialSettings - Fields to be patched
 * @param {Auth} auth - User validated authentication
 * @returns {Promise<SettingsPatchResponse>}
 */
function patch(_x4, _x5) {
  return _patch.apply(this, arguments);
}

function _patch() {
  _patch = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(partialSettings, _ref3) {
    var auth, signatureContent, signatureExtContent, _res, _res2, options, _endpoints$patch, method, url, res;

    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            auth = _ref3.auth;
            signatureContent = (0, _get["default"])(partialSettings, 'signature.content');
            signatureExtContent = (0, _get["default"])(partialSettings, 'signatureExt');

            if (!signatureContent) {
              _context6.next = 10;
              break;
            }

            _context6.next = 6;
            return updateSignature(signatureContent, auth);

          case 6:
            _res = _context6.sent;
            return _context6.abrupt("return", _res);

          case 10:
            if (!signatureExtContent) {
              _context6.next = 15;
              break;
            }

            _context6.next = 13;
            return updateSignatureExt(signatureExtContent, auth);

          case 13:
            _res2 = _context6.sent;
            return _context6.abrupt("return", _res2);

          case 15:
            options = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)((0, _functools.compose)(_requests.demomentize, reverseInboxZeroBackgroundMode)(partialSettings)))(_utils.defaultOptionals);
            _endpoints$patch = endpoints.patch, method = _endpoints$patch.method, url = _endpoints$patch.url;
            _context6.next = 19;
            return (0, _requests.request)(url(), method, options);

          case 19:
            res = _context6.sent;
            return _context6.abrupt("return", res);

          case 21:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _patch.apply(this, arguments);
}

/**
 * Reset all the settings
 *
 * @public
 * @param {Auth} auth - User validated authentication
 * @returns {Promise<SettingsResetResponse>}
 */
function reset(_x6) {
  return _reset.apply(this, arguments);
}
/**
 * Upload avatar to profile
 *
 * @public
 * @param {Blob} attachment - The avatar image file to upload
 * @param {Auth} auth - User validated authentication
 * @returns {Promise<APIResponse<string>>}
 */


function _reset() {
  _reset = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(_ref4) {
    var auth, options, _endpoints$reset, method, url, res;

    return _regenerator["default"].wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            auth = _ref4.auth;
            options = (0, _functools.compose)((0, _utils.withAuth)(auth));
            _endpoints$reset = endpoints.reset, method = _endpoints$reset.method, url = _endpoints$reset.url;
            _context7.next = 5;
            return (0, _requests.request)(url(), method, options);

          case 5:
            res = _context7.sent;
            return _context7.abrupt("return", res);

          case 7:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _reset.apply(this, arguments);
}

function uploadAvatar(_x7, _x8) {
  return _uploadAvatar.apply(this, arguments);
}

function _uploadAvatar() {
  _uploadAvatar = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(attachment, _ref5) {
    var auth, form, options, _endpoints$uploadAvat, method, url;

    return _regenerator["default"].wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            auth = _ref5.auth;
            form = new FormData();
            form.append('attachment', attachment);
            options = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)(form))(_utils.defaultOptionals);
            _endpoints$uploadAvat = endpoints.uploadAvatar, method = _endpoints$uploadAvat.method, url = _endpoints$uploadAvat.url;
            return _context8.abrupt("return", fetch(url('me'), _objectSpread({
              method: method
            }, options)).then(function () {
              return "".concat(url('me'), "?v=").concat((0, _moment["default"])().unix());
            }));

          case 6:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _uploadAvatar.apply(this, arguments);
}

function listForwardEmail(_x9) {
  return _listForwardEmail.apply(this, arguments);
}

function _listForwardEmail() {
  _listForwardEmail = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(_ref6) {
    var auth, options, _endpoints$listForwar, method, url, res;

    return _regenerator["default"].wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            auth = _ref6.auth;
            options = (0, _utils.withAuth)(auth)(_utils.defaultOptionals);
            _endpoints$listForwar = endpoints.listForwardEmail, method = _endpoints$listForwar.method, url = _endpoints$listForwar.url;
            _context9.next = 5;
            return (0, _requests.request)(url(), method, options);

          case 5:
            res = _context9.sent;
            return _context9.abrupt("return", res);

          case 7:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _listForwardEmail.apply(this, arguments);
}

function addForwardEmail(_x10, _x11) {
  return _addForwardEmail.apply(this, arguments);
}

function _addForwardEmail() {
  _addForwardEmail = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10(_ref7, _ref8) {
    var email, auth, options, _endpoints$addForward, method, url, res;

    return _regenerator["default"].wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            email = _ref7.email;
            auth = _ref8.auth;
            options = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)({
              emailAddress: email
            }))(_utils.defaultOptionals);
            _endpoints$addForward = endpoints.addForwardEmail, method = _endpoints$addForward.method, url = _endpoints$addForward.url;
            _context10.next = 6;
            return (0, _requests.request)(url(), method, options);

          case 6:
            res = _context10.sent;
            return _context10.abrupt("return", res);

          case 8:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return _addForwardEmail.apply(this, arguments);
}

function resendRecoveryVerifyEmail(_x12) {
  return _resendRecoveryVerifyEmail.apply(this, arguments);
}

function _resendRecoveryVerifyEmail() {
  _resendRecoveryVerifyEmail = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11(_ref9) {
    var auth, options, _endpoints$resendReco, method, url, res;

    return _regenerator["default"].wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            auth = _ref9.auth;
            options = (0, _functools.compose)((0, _utils.withAuth)(auth))(_utils.defaultOptionals);
            _endpoints$resendReco = endpoints.resendRecoveryVerifyEmail, method = _endpoints$resendReco.method, url = _endpoints$resendReco.url;
            _context11.next = 5;
            return (0, _requests.request)(url(), method, options);

          case 5:
            res = _context11.sent;
            return _context11.abrupt("return", res);

          case 7:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _resendRecoveryVerifyEmail.apply(this, arguments);
}

function deleteForwardEmail(_x13, _x14) {
  return _deleteForwardEmail.apply(this, arguments);
}

function _deleteForwardEmail() {
  _deleteForwardEmail = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee12(_ref10, _ref11) {
    var email, auth, options, _endpoints$deleteForw, method, url, res;

    return _regenerator["default"].wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            email = _ref10.email;
            auth = _ref11.auth;
            options = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)({
              emailAddress: email
            }))(_utils.defaultOptionals);
            _endpoints$deleteForw = endpoints.deleteForwardEmail, method = _endpoints$deleteForw.method, url = _endpoints$deleteForw.url;
            _context12.next = 6;
            return (0, _requests.request)(url(), method, options);

          case 6:
            res = _context12.sent;
            return _context12.abrupt("return", res);

          case 8:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));
  return _deleteForwardEmail.apply(this, arguments);
}

function exportData(_x15) {
  return _exportData.apply(this, arguments);
}

function _exportData() {
  _exportData = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee13(auth) {
    var options, _endpoints$exportData, method, url, res;

    return _regenerator["default"].wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            options = (0, _functools.compose)((0, _utils.withAuth)(auth))(_utils.defaultOptionals);
            _endpoints$exportData = endpoints.exportData, method = _endpoints$exportData.method, url = _endpoints$exportData.url;
            _context13.next = 4;
            return (0, _requests.request)(url(), method, options);

          case 4:
            res = _context13.sent;
            return _context13.abrupt("return", res);

          case 6:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));
  return _exportData.apply(this, arguments);
}

function fetchExportData(_x16) {
  return _fetchExportData.apply(this, arguments);
}

function _fetchExportData() {
  _fetchExportData = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee14(auth) {
    var incAll,
        options,
        _endpoints$fetchExpor,
        method,
        url,
        res,
        _args14 = arguments;

    return _regenerator["default"].wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            incAll = _args14.length > 1 && _args14[1] !== undefined ? _args14[1] : true;
            options = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withParams)({
              incAll: incAll
            }))(_objectSpread(_objectSpread({}, _utils.defaultOptionals), {}, {
              paramsFormat: _objectSpread(_objectSpread({}, _utils.defaultOptionals.paramsFormat), {}, {
                snakify: false
              })
            }));
            _endpoints$fetchExpor = endpoints.fetchExportData, method = _endpoints$fetchExpor.method, url = _endpoints$fetchExpor.url;
            _context14.next = 5;
            return (0, _requests.request)(url(), method, options);

          case 5:
            res = _context14.sent;
            return _context14.abrupt("return", res);

          case 7:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));
  return _fetchExportData.apply(this, arguments);
}

function updateSignature(_x17, _x18) {
  return _updateSignature.apply(this, arguments);
}

function _updateSignature() {
  _updateSignature = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee15(signatureContent, auth) {
    var options, _endpoints$updateSign, method, url, res;

    return _regenerator["default"].wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            options = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)({
              signatureContent: signatureContent
            }))(_utils.defaultOptionals);
            _endpoints$updateSign = endpoints.updateSignature, method = _endpoints$updateSign.method, url = _endpoints$updateSign.url;
            _context15.next = 4;
            return (0, _requests.request)(url(), method, options);

          case 4:
            res = _context15.sent;
            return _context15.abrupt("return", res);

          case 6:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));
  return _updateSignature.apply(this, arguments);
}

function updateSignatureExt(_x19, _x20) {
  return _updateSignatureExt.apply(this, arguments);
}

function _updateSignatureExt() {
  _updateSignatureExt = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee16(signatureContent, auth) {
    var options, _endpoints$updateSign2, method, url, res;

    return _regenerator["default"].wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            options = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)(signatureContent))(_utils.defaultOptionals);
            _endpoints$updateSign2 = endpoints.updateSignatureExt, method = _endpoints$updateSign2.method, url = _endpoints$updateSign2.url;
            _context16.next = 4;
            return (0, _requests.request)(url(), method, options);

          case 4:
            res = _context16.sent;
            return _context16.abrupt("return", res);

          case 6:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16);
  }));
  return _updateSignatureExt.apply(this, arguments);
}

function uploadInboxZeroBackground(_x21, _x22) {
  return _uploadInboxZeroBackground.apply(this, arguments);
}

function _uploadInboxZeroBackground() {
  _uploadInboxZeroBackground = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee17(file, _ref12) {
    var auth, form, options, _endpoints$uploadInbo, method, url, resp, json, _json$result, backgroundImageMode, backgroundImageFilename;

    return _regenerator["default"].wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            auth = _ref12.auth;
            form = new FormData();
            form.append('img', file);
            options = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)(form))(_utils.defaultOptionals);
            _endpoints$uploadInbo = endpoints.uploadInboxZeroBackground, method = _endpoints$uploadInbo.method, url = _endpoints$uploadInbo.url;
            _context17.next = 7;
            return fetch(url(), _objectSpread({
              method: method
            }, options));

          case 7:
            resp = _context17.sent;
            _context17.next = 10;
            return resp.json();

          case 10:
            json = _context17.sent;

            if (resp.ok) {
              _context17.next = 13;
              break;
            }

            throw new _requests.RequestError(json.message, json.error_code, resp.status, resp.headers);

          case 13:
            _json$result = json.result, backgroundImageMode = _json$result.backgroundImageMode, backgroundImageFilename = _json$result.backgroundImageFilename;
            return _context17.abrupt("return", _objectSpread(_objectSpread({}, json), {}, {
              result: {
                backgroundImageFilename: backgroundImageFilename,
                backgroundImageMode: backgroundImageMode !== _constants.inboxZeroBackgroundTypes.NONE
              }
            }));

          case 15:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17);
  }));
  return _uploadInboxZeroBackground.apply(this, arguments);
}

function deleteInboxZeroBackground(_x23, _x24) {
  return _deleteInboxZeroBackground.apply(this, arguments);
}

function _deleteInboxZeroBackground() {
  _deleteInboxZeroBackground = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee18(name, _ref13) {
    var auth, options, _endpoints$deleteInbo, method, url, res;

    return _regenerator["default"].wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            auth = _ref13.auth;
            options = (0, _utils.withAuth)(auth)(_utils.defaultOptionals);
            _endpoints$deleteInbo = endpoints.deleteInboxZeroBackground, method = _endpoints$deleteInbo.method, url = _endpoints$deleteInbo.url;
            _context18.next = 5;
            return (0, _requests.request)(url(name), method, options);

          case 5:
            res = _context18.sent;
            return _context18.abrupt("return", res);

          case 7:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18);
  }));
  return _deleteInboxZeroBackground.apply(this, arguments);
}

function unsubscribeWelcomeEmails(_x25) {
  return _unsubscribeWelcomeEmails.apply(this, arguments);
}

function _unsubscribeWelcomeEmails() {
  _unsubscribeWelcomeEmails = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee19(_ref14) {
    var auth, options, _endpoints$unsubscrib, method, url, res;

    return _regenerator["default"].wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            auth = _ref14.auth;
            options = (0, _utils.withAuth)(auth)(_utils.defaultOptionals);
            _endpoints$unsubscrib = endpoints.unsubscribeWelcomeEmails, method = _endpoints$unsubscrib.method, url = _endpoints$unsubscrib.url;
            _context19.next = 5;
            return (0, _requests.request)(url(), method, options);

          case 5:
            res = _context19.sent;
            return _context19.abrupt("return", res);

          case 7:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19);
  }));
  return _unsubscribeWelcomeEmails.apply(this, arguments);
}

var makeRecoveryMethodRequest = function makeRecoveryMethodRequest(endpoint) {
  return /*#__PURE__*/function () {
    var _ref16 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(payload, _ref15) {
      var captcha, options, method, url, res;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              captcha = _ref15.captcha;
              options = (0, _functools.compose)((0, _utils.withCaptcha)(captcha), (0, _requests.withBody)(payload))(_utils.defaultOptionals);
              method = endpoint.method, url = endpoint.url;
              _context.next = 5;
              return (0, _requests.request)(url(), method, options);

            case 5:
              res = _context.sent;
              return _context.abrupt("return", res);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x26, _x27) {
      return _ref16.apply(this, arguments);
    };
  }();
};

var makeRecoveryMethodWithoutCaptchaRequest = function makeRecoveryMethodWithoutCaptchaRequest(endpoint) {
  return /*#__PURE__*/function () {
    var _ref17 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(payload) {
      var options, method, url, res;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              options = (0, _requests.withBody)(payload)(_utils.defaultOptionals);
              method = endpoint.method, url = endpoint.url;
              _context2.next = 4;
              return (0, _requests.request)(url(), method, options);

            case 4:
              res = _context2.sent;
              return _context2.abrupt("return", res);

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x28) {
      return _ref17.apply(this, arguments);
    };
  }();
};
/*
 * Send SMS code
 *
 * @params {string} phoneNumber
 */


var sendSMSCode = makeRecoveryMethodRequest(endpoints.sendSMSCode);
/*
 * Verify SMS code
 *
 * @params {string} phoneNumber
 * @params {string} code
 */

exports.sendSMSCode = sendSMSCode;
var verifySMSCode = makeRecoveryMethodWithoutCaptchaRequest(endpoints.verifySMSCode);
/*
 * Send Email code
 *
 * @params {string} email
 */

exports.verifySMSCode = verifySMSCode;
var sendEmailCode = makeRecoveryMethodRequest(endpoints.sendEmailCode);
/*
 * Verify Email code
 *
 * @params {string} email
 * @params {string} code
 */

exports.sendEmailCode = sendEmailCode;
var verifyEmailCode = makeRecoveryMethodWithoutCaptchaRequest(endpoints.verifyEmailCode);
exports.verifyEmailCode = verifyEmailCode;

var makeRecoveryMethodUpdateRequest = function makeRecoveryMethodUpdateRequest(endpoint, withToken) {
  return /*#__PURE__*/function () {
    var _ref19 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(payload, _ref18) {
      var auth, token, options, method, url, res;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              auth = _ref18.auth, token = _ref18.token;
              options = (0, _functools.compose)((0, _utils.withExtraAuth)(auth), (0, _requests.withBody)(payload))(_utils.defaultOptionals);

              if (token && withToken) {
                options = withToken(token)(options);
              }

              method = endpoint.method, url = endpoint.url;
              _context3.next = 6;
              return (0, _requests.request)(url(), method, options);

            case 6:
              res = _context3.sent;
              return _context3.abrupt("return", res);

            case 8:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x29, _x30) {
      return _ref19.apply(this, arguments);
    };
  }();
};
/*
 * Update phone number for account recovery
 *
 * @params {string} phoneNumber
 * @params {ExtraAuth} auth
 * @params {string} token - token from the code verification
 */


var updateRecoveryPhone = makeRecoveryMethodUpdateRequest(endpoints.updateRecoveryPhone, _utils.withPhoneNumberToken);
/*
 * Remove the phone number used in account recovery
 *
 * @params {ExtraAuth} auth
 */

exports.updateRecoveryPhone = updateRecoveryPhone;

var removeRecoveryPhone = function removeRecoveryPhone(args) {
  return makeRecoveryMethodUpdateRequest(endpoints.removeRecoveryPhone)({}, args);
};
/*
 * Update email for account recovery
 *
 * @params {string} email
 * @params {ExtraAuth} auth
 * @params {string} token - token from the code verification
 */


exports.removeRecoveryPhone = removeRecoveryPhone;
var updateRecoveryEmail = makeRecoveryMethodUpdateRequest(endpoints.updateRecoveryEmail, _utils.withEmailCodeToken);
/*
 * Remove the email used in account recovery
 *
 * @params {ExtraAuth} auth
 */

exports.updateRecoveryEmail = updateRecoveryEmail;

var removeRecoveryEmail = function removeRecoveryEmail(args) {
  return makeRecoveryMethodUpdateRequest(endpoints.removeRecoveryEmail)({}, args);
};

exports.removeRecoveryEmail = removeRecoveryEmail;
//# sourceMappingURL=settings.js.map